import { Chip } from "@mui/material";

interface Props {
  status: ShipmentStatusValue | undefined;
  size: "small" | "medium" | undefined;
  lostByCarrier?: boolean;
}

export function ShipmentStatusBadge(props: Props) {
  const { status, size, lostByCarrier = false } = props;

  const getBadgeColor = ():
    "primary" | "success" | "warning" | "info" | "error" => {
    if (lostByCarrier) {
      return "warning";
    }
    switch (status) {
      case "ACTIVE":
        return "primary";
      case "BOOKED":
      case "DELIVERED":
      case "PICKED_UP":
        return "success";
      case "EXPIRED":
        return "warning";
      case "CANCELLED":
      case "BOOKING_CANCELLED":
        return "error";
      default:
        return "info";
    }
  };

  const getLabel = (): string => {
    if (lostByCarrier) {
      return "SHIPMENT LOST";
    }
    if (status === "ACTIVE") {
      return "ACCEPTING QUOTES";
    }
    if (status === "BOOKING_CANCELLED") {
      return "BOOKING CANCELLED";
    }
    if (status === "PICKED_UP") {
      return "PICKED UP";
    }
    return status ?? "unknown";
  };

  return (
    <Chip
      variant="outlined"
      size={size}
      label={getLabel()}
      color={getBadgeColor()}
    />
  );
}
